<script>
import MetaData from '@/components/common/metaData/MetaData.vue'

export default {
  components: {
    MetaData
  },
  props: {
    item: {
      type: Object
    },
    content: {
      type: Object
    }
  },
  data() {
    return {
      loading: true
    }
  },
  created() {
    this.getFileMetaData()
  },
  methods: {
    //get document property
    async getFileMetaData() {
      if (!this.item.documentMetaData) {
        await this.$uploadService
          .getFileMetaData(this.item.documentId)
          .then(res => {
            this.item.documentMetaData = res
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.loading = false
      }
    }
  }
}
</script>
<template>
  <v-expansion-panel id="upload_validation_details_document_properties">
    <v-expansion-panel-header>
      {{ $t('component.documentValidation.documentDetailsProperties.document.property') }}
    </v-expansion-panel-header>
    <v-expansion-panel-content v-if="loading">
      {{ $t('component.documentValidation.documentDetailsProperties.loading') }}
      <v-progress-linear indeterminate></v-progress-linear>
    </v-expansion-panel-content>
    <v-expansion-panel-content v-else>
      <MetaData :meta-data="item.documentMetaData" class="mt-1 mr-1 ml-1" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
